import React, { Component, useEffect, useState, useMemo } from "react";
// import Link from "next/link";
import styles from "./BloodStationNeedCard.module.scss";
import { IBloodStationsNeed } from "../../../../entities/bloodStationsNeed_common";
import { inject, observer } from "mobx-react";
import { BLOOD_GROUPS, VERY_SHORT_BLOOD_GROUPS } from "../../../../entities";
import plural from "plural-ru";
import { User } from "../../../../entities";
import redirectTo from "../../../../utils/redirectTo";
import { sendMetrics, wordsByGender } from "../../../../utils/misc";
import UserAvatar from "../../../ui/userAvatar";
import Button from "../../ui/button/Button";
import AuthStore from "../../../../stores/AuthStore";
import BloodStationStore from "../../../../stores/BloodStationStore";

type TBloodStationNeedCard = {
  bloodStationsStore: BloodStationStore;
  data?: IBloodStationsNeed;
  authStore?: AuthStore;
};

const BloodStationNeedCard: React.FC<TBloodStationNeedCard> = ({
  bloodStationsStore,
  data,
  authStore,
}) => {
  const { user } = authStore;
  const [activeNeed, setActiveNeed] = useState({
    isSelectedGroup: false,
    selectedGroup: null,
    isSelectedNeed: false,
  });

  const [plannedUsers, setPlannedUsers] = useState({
    totalCount: 0,
    users: null,
    usersImages: [],
  });

  useEffect(() => {
    bloodStationsStore.getPlannedUserCount(data.id).then((r) => {
      const users = r.results.map((user: User) => user);
      setPlannedUsers({
        ...plannedUsers,
        totalCount: r.count,
        users: users || null,
        usersImages: users?.slice(0, 3) || [],
      });
    });
    if (user?.blood_group) {
      setActiveNeed({
        isSelectedGroup: true,
        selectedGroup: user?.blood_group,
        isSelectedNeed: getInfoAboutNeeded(user?.blood_group),
      });
    }
  }, []);

  const userOutput = () => {
    const { users } = plannedUsers;
    const userCount = users?.length;

    if (userCount >= 3) {
      const preOut = users
        .slice(0, 2)
        .map((user) => user.first_name)
        .join(", ");

      if (userCount === 3)
        return (
          preOut + ` и ${users[2]?.first_name} запланировали сдать кровь здесь`
        );

      return (
        preOut +
        ` и еще ${userCount - 2} ${plural(
          userCount - 2,
          "донор",
          "донора",
          "доноров"
        )} ${plural(
          userCount - 2,
          "запланировал",
          "запланировали",
          "запланировали"
        )} сдать кровь здесь`
      );
    }

    if (userCount === 2)
      return (
        `${users[0]?.first_name} и ${users[1]?.first_name}` +
        " запланировали сдать кровь здесь"
      );

    if (userCount === 1)
      return `${users[0]?.first_name} ${wordsByGender(
        users[0]?.first_name,
        "запланировал",
        "запланировала"
      )} сдать кровь здесь`;
  };

  const needs = useMemo(() => {
    return {
      o_plus: data?.o_plus,
      a_plus: data?.a_plus,
      b_plus: data?.b_plus,
      ab_plus: data?.ab_plus,
      o_minus: data?.o_minus,
      a_minus: data?.a_minus,
      b_minus: data?.b_minus,
      ab_minus: data?.ab_minus,
    };
  }, [data]);

  const getInfoAboutNeeded = (key: any) => {
    return needs ? needs[key] === "need" : null;
  };

  const setActiveNeedHandler = (key: any) => {
    setActiveNeed({
      isSelectedGroup: true,
      selectedGroup: key,
      isSelectedNeed: getInfoAboutNeeded(key),
    });
  };

  const onClickHandler = () => {
    redirectTo(
      `/bloodstations/${data.id}?utm_source=profile&utm_medium=bloodstation&utm_campaign=donor_search`
    );
  };

  if (!data) return null;

  return (
    <>
      {/* нзавание центра */}
      <div className={styles.header}>
        <h5 className={styles.title}>{data.title}</h5>
        {/* адрес */}
        <p className={styles.address}>
          {[data.city.title, data.address].join(", ")}
        </p>
      </div>

      <div className={styles.body}>
        {/* значок требуется */}
        <div className={styles.legend}>
          <div className={styles.legend__item_red}>
            <span>Требуется</span>
          </div>
          {/* значок достаточно */}
          <div className={styles.legend__item_green}>
            <span>Достаточно</span>
          </div>
        </div>
        {/* лейблы с нуждами групп крови */}
        <div className={styles.needsList}>
          {Object.values(needs).includes("unknown") ? (
            <span>Нет данных</span>
          ) : (
            Object.keys(needs).map((item) => {
              const isNeeded = needs[item] === "need" ? true : false;

              return (
                <div
                  key={item}
                  className={
                    isNeeded ? styles.needsItem_red : styles.needsItem_green
                  }
                  onClick={() => {
                    setActiveNeedHandler(item);
                  }}
                  data-focused={activeNeed.selectedGroup === item}
                >
                  {VERY_SHORT_BLOOD_GROUPS[item]}
                </div>
              );
            })
          )}
        </div>
        {/* расскрывающееся описание выбранной группы крови */}
        <div className={styles.needsInfo}>
          {activeNeed.isSelectedGroup && (
            <>
              <span>{BLOOD_GROUPS[activeNeed.selectedGroup]}</span>
              <p>
                {activeNeed.isSelectedNeed &&
                  "Готовы принять с данной группой крови"}
                {!activeNeed.isSelectedNeed &&
                  "Запасов крови данной группы достаточно"}
              </p>
            </>
          )}
        </div>
      </div>

      <div className={styles.footer}>
        {/* запланированные пользователи */}
        {plannedUsers.users?.length > 0 && (
          <div className={styles.userList}>
            <span className={styles.userList__count}>{userOutput()}</span>

            <div className={styles.userList__photos}>
              {plannedUsers?.usersImages?.map((user, i) => {
                return (
                  <UserAvatar
                    key={`user_${user.id}_${i}`}
                    user={user}
                    scale={34}
                    style={{ width: "32px" }}
                  />
                );
              })}
            </div>
          </div>
        )}
        {/* ссылка для перехода */}
        <Button children={"Перейти"} onClick={onClickHandler} />
      </div>
    </>
  );
};

export default inject(
  "bloodStationsStore",
  "authStore"
)(observer(BloodStationNeedCard));
